import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { notifyPdfNoStamp } from "@/lib/printNotice";
import { FileText, Printer } from "lucide-react";
import { mediaToSize } from "@/lib/tagMedia";
import { ScanTextInput } from "@/components/ScanTextInput";

// RE-PRINT ONE CODE BY HAND — for a sticker that got torn off, and for a stock test. Any code
// prints; a real one pulls its own saved QR token, so the replacement scans like the original.
export const HandPrintDialog = ({ open, onClose, onPrintOne, media = "sticker" }) => {
  const [code, setCode] = useState("");

  const pdf = async () => {
    const v = code.trim();
    if (!v) { toast.error("Type a code first."); return; }
    try {
      const res = await api.get("/locations/label-pdf", { params: { value: v, size: mediaToSize(media) }, responseType: "blob" });
      window.open(URL.createObjectURL(res.data), "_blank");
      notifyPdfNoStamp();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent data-testid="hand-print-dialog" className="rounded-xl border-slate-200 sm:max-w-md">
        <DialogHeader><DialogTitle className="font-display">Re-print one code by hand</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">A real code pulls its own saved QR token, so the new sticker scans exactly like the one it replaces. An unsaved code still prints — useful for testing the stock.</p>
        <ScanTextInput testid="hand-print-code" autoFocus value={code} onChange={(v) => setCode(v.toUpperCase())}
          onEnter={() => { if (code.trim()) onPrintOne(code.trim()); }}
          placeholder="e.g. VCR-003-L2" inputClassName="h-11" autoComplete="off" />
        <DialogFooter>
          <Button variant="outline" className="rounded-lg border-slate-200 h-11" onClick={onClose}>Cancel</Button>
          <Button data-testid="hand-print-pdf" variant="outline" className="rounded-lg border-slate-200 h-11" onClick={pdf}>
            <FileText className="w-4 h-4 mr-1.5" />PDF
          </Button>
          <Button data-testid="hand-print-zpl" disabled={!code.trim()} onClick={() => onPrintOne(code.trim())}
            className="rounded-lg h-11 bg-[#1F1F1F] hover:bg-black text-white">
            <Printer className="w-4 h-4 mr-1.5" />Print
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
